<template>
  <div class="container">
    <div class="center">
      <img
        class="mb-4"
        style="width:200px"
        src="../assets/iSimulate-Logo.svg"
      />
      <h6>Unverified account</h6>
    </div>
    <p>
      <small>Please check your email inbox and click the link to verify your email address.</small>
    </p>
    <p>
      <small>
      If you didn't receive the email, please click <button class="link" @click="resend()">here</button> to re-send it.
      </small>
    </p>
    <small class="form-text text-muted" style="margin-top: 16px;">
      <router-link tag="span" class="small-link" to="/logout">Go to login page</router-link>
    </small>
  </div>
</template>

<script>
import userService from '../services/user.service';
import logger from '../utils/logger';
export default {
  name: "UnverifiedProfile",
  data: function() {
    return {
      sendingEmail: false
    }
  },
  computed: {
    currentDistributor() {
      return this.$store.getters.getDistributor;
    },
  },
  methods: {
      resend() {
        if (this.sendingEmail) return;
        this.sendingEmail = true;

        var email = this.$route.params.email; 
        userService.resendVerificationEmail(email, this.currentDistributor)
          .then(() => logger.log("auth.resend_verification.sent", "Verification email sent"))
          .catch((err) => logger.error("auth.resend_verification.failure", err))
          .finally(() => this.sendingEmail = false);
      }
  }
};
</script>

<style scoped>
.container {
  margin: 40px auto;
  max-width: 340px;
}

.center {
  text-align: center;
  margin-bottom: 30px;
}

.small-link {
    cursor: pointer;
    font-weight: bold;
}

.link {
    border-radius: 3px;
}
</style>
